import { FeatureGates } from 'common/types/account';

export const mergeFeatureGates = (featureGates: FeatureGates, studyId?: string): string[] => {
  if (!studyId) return featureGates.customer || [];
  // The response (and e2e mocks) may omit `studies`.
  const studyFeatureGates = featureGates.studies?.[studyId] || [];
  const customerFeatureGates = featureGates.customer || [];
  return [...studyFeatureGates, ...customerFeatureGates];
};
